import { StatusMessage, SelectionSet, SelectionSetInput, SelectionSetLabel, SelectionSetTileContents, SelectionSetTileName, SelectionSetTilePrice } from '@vp/swan';
import React, { useState, useContext, useCallback, useEffect } from 'react';
import { ChatbotContext } from './src-contexts-ChatbotContext.js';
import { CAContext } from './src-contexts-CAContext.js';
import { util } from './src-utils-miaw-common.js';
import { DISPLAY_NAME } from './src-config-app-config.js';
import PrechatForm from './src-components-PrechatFormInline-PrechatFormInline.js';
import { useCustomTracking } from './src-hooks-custom-hooks-useTracking.js';
import { useIdentity } from '@vp/auth-react';
import { useGenerateAcw } from './src-hooks-useGenerateAcw.js';
import { getQuestfromIntent } from './src-utils-miaw-init-chat-utils.js';
import { useNRLogging } from './src-hooks-custom-hooks-useNRLogging.js';

const ButtonGroup = ({ actionList, onSelect, postion = "end", type, typeOfFLow }) => {
  const [showWarningMessage, setShowWarningMessage] = useState(false);
  const { logCustomAttributesNR } = useNRLogging();
  const {
    chatState: { userInfo },
    setChatState
  } = useContext(CAContext);
  const {
    state: { sendChatbotMessage, sessionId, selectedProductIds, orderNumber },
    setState
  } = useContext(ChatbotContext);
  const { sendTrackingEvent } = useCustomTracking();
  const identity = useIdentity();
  const { summaryAPI } = useGenerateAcw();
  const handleStartMIAWChatWithPrechat = useCallback(
    (data) => {
      setChatState((prevState) => ({
        ...prevState,
        userInfo: {
          isLoggedIn: prevState.userInfo?.isLoggedIn ?? false,
          userData: {
            firstName: data.firstName,
            lastName: data.lastName,
            email: data.email,
            shopperId: identity.canonicalId || "",
            chatbotContactReason: data?.chatbotContactReason || "",
            orderNumber: data?.orderNumber || ""
          }
        }
      }));
      setState((prevState) => ({
        ...prevState,
        conversationMessages: [
          ...prevState.conversationMessages,
          {
            id: util.generateUUID(),
            messageContent: userInfo?.isLoggedIn && userInfo?.userData ? data.isSummaryGenerated ? "" : data.chatbotContactReason : typeOfFLow === "nonLoggedInPreChatWithOrderNumber" ? `${data.firstName}
${data.lastName}
${data.email}${data.orderNumber ? `
${data.orderNumber}` : ""}` : `${data.firstName}
${data.lastName}
${data.email}`,
            timestamp: (/* @__PURE__ */ new Date()).getTime(),
            type: "user",
            isMessageRead: false,
            showFeedback: false
          }
        ]
      }));
      setState((prevState) => ({
        ...prevState,
        conversationMessages: prevState.conversationMessages.map((message) => {
          if (message.customMessageType === "prechatMessage") {
            return { ...message, additionalComponents: void 0 };
          }
          return message;
        })
      }));
    },
    [sessionId, setChatState, setState, identity]
  );
  const onOptionSelect = async (value) => {
    if (value === "agentConnect") {
      sendTrackingEvent("Chatbot Clicked", "Chatbot:Escalation", "escalationTriggered");
      if (typeOfFLow !== "transferToAgent" && typeOfFLow !== "nonLoggedInPreChatWithOrderNumber") {
        setState((prevState) => ({
          ...prevState,
          conversationMessages: [
            ...prevState.conversationMessages,
            {
              id: util.generateUUID(),
              messageContent: "Chat with a specialist",
              timestamp: (/* @__PURE__ */ new Date()).getTime(),
              type: "user",
              isMessageRead: false,
              showFeedback: false
            }
          ]
        }));
      }
      let isAcwAPIGeneratedSummary;
      try {
        setState((prev) => {
          const updateConversationMessages = prev.conversationMessages.map((message, index) => {
            if (index === prev.conversationMessages.length - 2) {
              return { ...message, additionalComponents: void 0 };
            }
            return message;
          });
          return { ...prev, isSendMessageLoading: true, conversationMessages: [...updateConversationMessages] };
        });
        const response = await summaryAPI();
        logCustomAttributesNR("ca-chatbot-info", {
          logName: "summary_api_success",
          logLevel: "info",
          message: `Summary API Response: ${response}`
        });
        let customQueue;
        if (response?.intent && response?.intent !== "NA" && response?.intent !== "") {
          customQueue = getQuestfromIntent(response?.intent);
        }
        setChatState((prev) => ({
          ...prev,
          chatbotSummaryResponse: response,
          customQueue
        }));
        isAcwAPIGeneratedSummary = response?.summary == "NA" || response?.summary == "" ? "" : response?.summary;
        setState((prev) => ({
          ...prev,
          isSendMessageLoading: false
        }));
      } catch (error) {
        logCustomAttributesNR("ca-chatbot-error", {
          logName: "summary_api_fail",
          logLevel: "error",
          message: `summary API Error: ${error}`
        });
        setState((prev) => ({
          ...prev,
          isSendMessageLoading: false
        }));
        isAcwAPIGeneratedSummary = false;
        console.error("Error fetching summary:", error);
      }
      const prechatMessage = "Okay! To connect you with a specialist, I just need a bit more information about why you\u2019re reaching out:";
      const shouldShowMessage = !isAcwAPIGeneratedSummary && typeOfFLow !== "nonLoggedInPreChatWithOrderNumber" || isAcwAPIGeneratedSummary && !userInfo?.isLoggedIn && typeOfFLow !== "nonLoggedInPreChatWithOrderNumber";
      setState((prevState) => ({
        ...prevState,
        conversationMessages: [
          ...prevState.conversationMessages,
          {
            id: util.generateUUID(),
            messageContent: shouldShowMessage ? prechatMessage : "",
            timestamp: (/* @__PURE__ */ new Date()).getTime(),
            type: "chatbot",
            isMessageRead: false,
            senderDisplayName: DISPLAY_NAME.CHATBOT,
            additionalComponents: /* @__PURE__ */ React.createElement(PrechatForm, { onSubmit: handleStartMIAWChatWithPrechat, correctSummary: false, typeOfFLow }),
            customMessageType: "prechatMessage",
            showFeedback: false
          }
        ]
      }));
      return;
    }
    if (typeOfFLow === "moneyBack") {
      sendChatbotMessage?.({
        type: "text_message_with_different_query",
        messageData: {
          messageText: value,
          query: `I would prefer ${value} for Order ID - ${orderNumber} and Product ID - [${selectedProductIds}]`
        }
        // Send query to the chatbot
      });
      onSelect?.(value);
      return;
    }
    const isPreChatFlowButton = actionList.length === 2 && actionList.some((item) => item.label === "Yes" && item.value === "Yes" && item.isPreChatFlowButton) && actionList.some((item) => item.label === "No" && item.value === "No" && item.isPreChatFlowButton);
    if (!isPreChatFlowButton) {
      sendChatbotMessage?.({ type: "text_message", messageData: value });
    }
    if (typeOfFLow !== "transferToAgent" && typeOfFLow !== "nonLoggedInPreChatWithOrderNumber") {
      onSelect?.(value);
    }
  };
  useEffect(() => {
    if (actionList.length && typeOfFLow === "moneyBack") {
      const hasMoneyOptionNotAvailable = actionList.some((item) => item.isOptionAvailable === false);
      if (hasMoneyOptionNotAvailable) {
        setShowWarningMessage(true);
      }
    }
  }, [actionList]);
  useEffect(() => {
    if (typeOfFLow === "transferToAgent" || typeOfFLow === "nonLoggedInPreChatWithOrderNumber") {
      onOptionSelect("agentConnect");
      if (typeOfFLow === "nonLoggedInPreChatWithOrderNumber") {
        logCustomAttributesNR("ca-chatbot-info", {
          logName: "request_cancelation_flow",
          logLevel: "info",
          message: `non logged in user requested for cancelation and directly transfer to specialist`
        });
      } else {
        logCustomAttributesNR("ca-chatbot-info", {
          logName: "money_back_no_remediation_flow",
          logLevel: "info",
          message: `money back flow with no remediation and directly transfer to specialist`
        });
      }
    }
  }, []);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, typeOfFLow === "moneyBack" && showWarningMessage && /* @__PURE__ */ React.createElement(StatusMessage, { skin: "warning", marginY: "between-actions", style: { paddingTop: "6px" } }, "Some solutions are not available"), /* @__PURE__ */ React.createElement(
    SelectionSet,
    {
      variant: "single-select",
      skin: type,
      onSelectedValueChange: (e) => {
        onOptionSelect(e);
      },
      marginTop: "between-actions",
      style: { justifyContent: postion },
      compactMode: true
    },
    actionList.map((action) => {
      return /* @__PURE__ */ React.createElement(
        SelectionSetInput,
        {
          value: action.value,
          key: action.value,
          disabled: type === "tiles-horizontal" && typeOfFLow === "moneyBack" && !action.isOptionAvailable
        },
        type === "buttons" ? /* @__PURE__ */ React.createElement(SelectionSetLabel, { mb: 4, style: { height: "fit-content" } }, action.label) : /* @__PURE__ */ React.createElement(SelectionSetLabel, { style: { minHeight: "60px" } }, /* @__PURE__ */ React.createElement(SelectionSetTileContents, null, /* @__PURE__ */ React.createElement(SelectionSetTileName, null, action.label), /* @__PURE__ */ React.createElement(SelectionSetTilePrice, null, action.description)))
      );
    })
  ));
};

export { ButtonGroup as default };
//# sourceMappingURL=src-components-AdvanceMessagingComponent-ButtonGroup-ButtonGroup.js.map
